export function parseDsn(dsn: string): { key: string; cluster: string } {
  const url = new URL(dsn)

  return {
    key: url.hostname,
    cluster: url.pathname.replace('/', ''),
  }
}
